import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import AverageProductSellFilter from "../filters/AverageProductSellFilter";
import fetchHook from "../../../../../hooks/fetchMSSQL-hook";
import getGradientForBarValue from "../../utils/getGradientForBarValue";
import getYearProductsSalesSumChartConfig from '../../configs/getYearProductsSalesSumChartConfig'
import getYearProductsSalesAverageChartConfig from '../../configs/getYearProductsSalesAverageChartConfig'

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
  annotationPlugin
);

export default function YearProductsSalesChart({showProductsStat, setShowProductsStat}) {
  const chartRef = useRef(null);
  const chartRef2 = useRef(null);
  const { fetchMssqlApi } = fetchHook();
  const [avarageProductsSale, setAvarageProductsSale] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [productFilter, setProductFilter] = useState("");
  const [productType, setProductType] = useState(1);
  const [productRank, setProductRank] = useState("all");
  const [sortType, setSortType] = useState(1);
  const [showAVG, setShowAVG] = useState(false);
  const [showMedian, setShowMedian] = useState(true);


  const getAvarageProductsSales = async () =>
    fetchMssqlApi(
      "/stat/year-products-sales",
      {
        method: "POST",
        hideNotification: true,
        data: { ProductType: productType },
      },
      (res) => {
        setAvarageProductsSale(res);
        sortData(sortType);
      },
      (err) => console.log(err)
    );


  const setLocalStorage = (value) => {
    try {
      const values = localStorage.getItem("statFilters");
      let parsedValue = {};
      
      if (values) {
        parsedValue = JSON.parse(values);
      }
      
      const updatedValue = { ...parsedValue, showYearProductsStat: value };
      localStorage.setItem("statFilters", JSON.stringify(updatedValue));
    } catch (e) {
      console.log("Error updating localStorage:", e);
    }
  };
  const filterByProductType = (productType) => {
    switch (parseInt(productType)) {
      case 1:
        return avarageProductsSale.filter(({ IsRecipe }) => !IsRecipe);
      case 2:
        return avarageProductsSale.filter(({ IsRecipe }) => IsRecipe);
      default:
        return avarageProductsSale;
    }
  };
  const filteredByType = avarageProductsSale
    ? filterByProductType(productType)
    : [];

    const filteredData = filteredByType

const calculateMedianOfAverages = () => {
  if (!filteredData || filteredData.length === 0) return 0;
  
  const sortedValues = [...filteredData]
    .map(product => parseFloat((Number(product.PrevAverageIncomeValue || 0) + Number(product.CurrentAverageIncomeValue || 0)) / 2 || 0))
    .sort((a, b) => a - b);
  
  const midIndex = Math.floor(sortedValues.length / 2);

  if (sortedValues.length % 2 !== 0) {
    return sortedValues[midIndex];
  } else {
    return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
  }
};

const calculateMedianOfSum = () => {
  if (!filteredData || filteredData.length === 0) return 0;
  
  const sortedValues = [...filteredData]
    .map(product => parseFloat((Number(product.PrevSummaryIncomeValue || 0) + Number(product.CurrentSummaryIncomeValue || 0)) / 2 || 0))
    .sort((a, b) => a - b);
  
  const midIndex = Math.floor(sortedValues.length / 2);
  
  if (sortedValues.length % 2 !== 0) {
    return sortedValues[midIndex];
  } else {
    return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
  }
};

const medianOfAverages = calculateMedianOfAverages();
const medianOfSum = calculateMedianOfSum();
const getAVGSUMByProductName = ({PrevSummaryIncomeValue, CurrentSummaryIncomeValue}) => {
  return Number(PrevSummaryIncomeValue || 0) + Number(CurrentSummaryIncomeValue || 0) || 0
}
const getAVGAVGByProductName = ({PrevAverageIncomeValue, CurrentAverageIncomeValue}) => {
  return Number(PrevAverageIncomeValue || 0) + Number(CurrentAverageIncomeValue || 0) || 0 
}
  const sortBySummaryASC = (a, b) =>
    getAVGSUMByProductName(a) > getAVGSUMByProductName(b) ? 1 : -1;
  const sortByAvarageASC = (a, b) =>
    getAVGAVGByProductName(a) > getAVGAVGByProductName(b) ? 1 : -1;
  const sortByProductNameASC = (a, b) =>
    a.ProductFullName > b.ProductFullName ? 1 : -1;
  const sortBySummaryDESC = (a, b) =>
    getAVGSUMByProductName(a) < getAVGSUMByProductName(b) ? 1 : -1;
  const sortByAvarageDESC = (a, b) =>
    getAVGAVGByProductName(a) < getAVGAVGByProductName(b) ? 1 : -1;
  const sortByProductNameDESC = (a, b) =>
    a.ProductFullName < b.ProductFullName ? 1 : -1;

  const sortData = (caseType) => {
    switch (+caseType) {
      case 1:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
      case 2:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByAvarageDESC)
        );
      case 3:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByProductNameDESC)
        );
      case 4:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortBySummaryASC)
        );
      case 5:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByAvarageASC)
        );
      case 6:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByProductNameASC)
        );
      default:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
    }
  };

  useEffect(() => {
    sortData(sortType);
  }, [sortType]);

  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  const applyRankFilter = (data) => {
    if (!data || data.length === 0) return [];
    switch (productRank) {
      case "best":
        return data.slice(0, 50);
      case "worst":
        return data.slice(Math.max(0, data.length - 50)); 
      case "all":
      default:
        return data; 
    }
  };
  const currentData = applyRankFilter(filteredData)


  useEffect(() => {
    setLocalStorage(showProductsStat);
  }, [showProductsStat]);

  useEffect(() => {
    setCurrentPage(1);
  }, [productFilter, productRank]); 

  useEffect(() => {
    if (showProductsStat) {
      getAvarageProductsSales();
    }
    if (!showProductsStat) {
      setProductFilter("");
    }
    setCurrentPage(1);
  }, [showProductsStat]);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
    if (chartRef2.current) {
      chartRef2.current.update();
    }
  }, [avarageProductsSale]);


  const calculateAverageOfAverages = () => {
    if (!avarageProductsSale || avarageProductsSale.length === 0) return 0;

    const sum = avarageProductsSale.reduce(
      (acc, product) => acc + parseFloat((Number(product.PrevAverageIncomeValue || 0) + Number(product.CurrentAverageIncomeValue || 0)) / 2 || 0),
      0
    );
    return sum / avarageProductsSale.length;
  };
  const calculateAverageOfSum = () => {
    if (!avarageProductsSale || avarageProductsSale.length === 0) return 0;

    const sum = avarageProductsSale.reduce(
      (acc, product) => acc + parseFloat((Number(product.PrevSummaryIncomeValue || 0) + Number(product.CurrentSummaryIncomeValue || 0)) / 2 || 0),
      0
    );
    return sum / avarageProductsSale.length;
  };

  const averageOfAverages = calculateAverageOfAverages();
  const averageOfSum = calculateAverageOfSum();

  const truncateProductName = (name) => {
    return name && name.length >30 ? name.substring(0, 30) + "..." : name;
  };

  const maxAvarageValue = Math.max(
    ...avarageProductsSale.map(getAVGAVGByProductName)
  );
  const maxSummaryValue = Math.max(
    ...avarageProductsSale.map(getAVGSUMByProductName)
  );
  const summaryChartRatio =
    ((maxAvarageValue || 1) / (averageOfSum || 1)).toFixed(1) || 0;
  const avarageChartRatio =
    ((maxSummaryValue || 1) / (averageOfAverages || 1)).toFixed(1) || 0;

    useEffect(() => {
      if (chartRef.current && chartRef.current.canvas) {
        try {
          const chart = chartRef.current;
  
          if (chart.data && chart.data.datasets) {
            chart.data.datasets[0].backgroundColor = currentData.map(
              (product) => {
                const value = parseFloat(product.CurrentAverageIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfAverages,
                  avarageChartRatio,
                );
              }
            );
            
            chart.data.datasets[1].backgroundColor = currentData.map(
              (product) => {
                const value = parseFloat(product.PrevAverageIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfAverages,
                  avarageChartRatio,
                );
              }
            );
  
            chart.update();
          }
        } catch (e) {
          console.error("Failed to apply gradients to first chart:", e);
          
        }
      }
  
      if (chartRef2.current && chartRef2.current.canvas) {
        try {
          const chart = chartRef2.current;
  
          if (chart.data && chart.data.datasets) {
            chart.data.datasets[0].backgroundColor = currentData.map(
              (product) => {
                const value = parseFloat(product.CurrentSummaryIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfSum,
                  summaryChartRatio,
                  'rgba(1, 64, 190, 0.9)',
                  'rgba(1, 64, 190, 0.3)'
                );
              }
            );
            
            chart.data.datasets[1].backgroundColor = currentData.map(
              (product) => {
                const value = parseFloat(product.PrevSummaryIncomeValue) || 0;
                return getGradientForBarValue(
                  chart,
                  value,
                  medianOfSum,
                  summaryChartRatio,
                  'rgba(197, 216, 255, 0.9)',
                  'rgba(197, 216, 255, 0.3)'
                );
              }
            );
  
            chart.update();
          }
        } catch (e) {
          console.error("Failed to apply gradients to second chart:", e);
        }
      }
    }, [currentData, currentPage, averageOfAverages, averageOfSum]);

  const chartData = {
    labels:
      currentData?.map((product) =>
        truncateProductName(product.ProductFullName)
      ) || [],
    datasets: [
      {
        label: "Bieżący rok",
        data:
          currentData?.map((product) =>
            parseFloat(product.CurrentAverageIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
      {
        label: "Poprzedni rok",
        data:
          currentData?.map((product) =>
            parseFloat(product.PrevAverageIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };

  const chartData2 = {
    labels:
      currentData?.map((product) =>
        truncateProductName(product.ProductFullName)
      ) || [],
    datasets: [
      {
        label: "Bieżący rok",
        data:
          currentData?.map((product) =>
            parseFloat(product.CurrentSummaryIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
      {
        label: "Poprzedni rok",
        data:
          currentData?.map((product) =>
            parseFloat(product.PrevSummaryIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };




  return (
    <div
      // className={`pb-2 ${
      //   showProductsStat && "border-top rounded"
      // }`}
    >
      <AverageProductSellFilter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        productFilter={productFilter}
        setProductFilter={setProductFilter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        filteredData={filteredData}
        totalCount={avarageProductsSale ? avarageProductsSale.length : 0}
        productType={productType}
        setProductType={setProductType}
        products={
          avarageProductsSale.length
            ? avarageProductsSale.map(({ ProductFullName }) => ProductFullName)
            : []
        }
        isVisible={showProductsStat}
        setIsVisible={setShowProductsStat}
        setSortType={setSortType}
        sortType={sortType}
        showAVG={showAVG}
        setShowAVG={setShowAVG}
        getData={getAvarageProductsSales}
        showMedian={showMedian}
        setShowMedian={setShowMedian}
        productRank={productRank}
        setProductRank={setProductRank}
        chartType="year"
        title="Sprzedaż roczna (produkty)"
      />
      {filteredData.length === 0 && productFilter && (
        <div
          className="alert"
          style={{ backgroundColor: "#C5D8FF", fontWeight: "bolder" }}
        >
          Nie znaleziono automatów pasujących do filtra "{productFilter}"
        </div>
      )}
      {showProductsStat && (
        <div
          className="container-fluid"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <div className="row">
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length) * 40
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              <Bar
                ref={chartRef}
                data={chartData}
                options={getYearProductsSalesAverageChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfAverages,
                  itemsPerPage,
                  showMedian,
                  medianOfAverages
                )}
              />
            </div>
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length) * 40
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              <Bar
                ref={chartRef2}
                data={chartData2}
                options={getYearProductsSalesSumChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfSum,
                  itemsPerPage,
                  showMedian,
                  medianOfSum
                )}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
